import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { buildRouteChangeMeta } from 'utils/routeChangeMeta';
import { useRouteChangeEventChannelEmitter } from './use-location-change-event-channel-emitter';

/**
 * Emits ROUTE_CHANGE for object/record pages. Sends resource immediately so the host can
 * link Custom Objects, then re-emits with object/record meta once entity data is available.
 * Pass `displayId` only on the record page so the list page does not emit record meta.
 */
export const useBreadcrumbRouteMetaEmitter = ({ entity, record, displayId } = {}) => {
  const { id } = useParams();
  const { emitRouteChangeEvent } = useRouteChangeEventChannelEmitter(false);

  useEffect(() => {
    const meta = entity ? buildRouteChangeMeta({ entity, record, routeParam: id, displayId }) : undefined;
    emitRouteChangeEvent(null, meta);
  }, [entity, record, id, displayId, emitRouteChangeEvent]);
};
